import AuthRepository from './public-auth'

export default PublicAuthService

PublicAuthService.$inject = [ 'AuthServer' ]
function PublicAuthService(AuthServer){
  const repo = AuthRepository(AuthServer)

  this.signUp = registrationModel => { return repo.signUp(registrationModel) }
  this.verifyEmailAddress = token => { return repo.verifyEmailAddress(token) }
  this.signIn = credentials => { return repo.signIn(credentials) }
  this.resetPassword = emailAddress => { return repo.resetPassword(emailAddress) }
  this.verifyResetPasswordToken = token => { return repo.verifyResetPasswordToken(token) }
  this.setPassword = (token, password) => { return repo.setPassword(token, password) }
}
